export default __webpack_public_path__ + "static/media/spain.b16ac385.webp";